/* eslint-disable-next-line react-hooks/exhaustive-deps */
import React, { useReducer, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import * as service from '../services/api';
import { STRIPE_KEY } from '../constants';
import { ENV } from '../config/env';

import { Layout } from '../components/layout/Layout';
import { Account } from '../components/features/Account/Account';
// import { Payment } from '../components/features/Payment/Payment';
// import { Confirmation } from '../components/features/Confirmation/Confirmation';
// import { RegisterStep1, RegisterStep2 } from '../components/features/Register';

import { AccountStateType, AccountActionType } from '../types/account';
import { withReducerLogger } from '../utils/debugReducer';

const stripePromise = loadStripe(STRIPE_KEY);
const initialState: AccountStateType = {
  step: 1,
  loading: false,
  tab: 'detail',
  user: null,
  doc: null,
  subscription: null,
  loadingText: 'Checking your credentials...',
  products: []
};

const reducer = (state: AccountStateType, action: AccountActionType): AccountStateType => {
  switch (action.type) {
    case 'set_page':
      return { ...state, step: 1 };
    case 'loaded':
      return { ...state, loading: false, ...action };
    case 'set_tab':
      return { ...state, tab: action.tab };
    case 'loading':
      return { ...state, loading: true, loadingText: action.loadingText };
    case 'payment':
      return { ...state, step: 2, loading: false };
    case 'set_card':
      return { ...state, payment: action.payload };
    case 'success':
      return { ...state, step: 3, loading: false, doc: action.payload };
    case 'set_details':
      return { ...state, details: action.payload, step: 5 };
    case 'set_promo':
      return { ...state, promo: action.payload };
    case 'renew':
      return { ...state, step: 4 };
    case 'products':
      return { ...state, products: action.payload };
    default:
      return state;
  }
};

const AccountContent: React.FC = () => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(
    ENV.isDevelopment ? withReducerLogger(reducer) : reducer,
    initialState
  );

  // Fetch Products
  useMemo(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(service.API_ENDPOINTS.getProductsList, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        dispatch({ type: 'products', payload: data?.products?.data || [] });
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);

  // Check query params
  useEffect(() => {
    const queryParams = new URLSearchParams(window?.location?.search || '');
    if (queryParams.get('page') === '1/') {
      dispatch({ type: 'set_page' });
      navigate('/account/');
    }
  }, [navigate]);

  const renderStep = () => {
    switch (state.step) {
      case 1:
        return (
          <Elements stripe={stripePromise}>
            <Account state={state} dispatch={dispatch} />
          </Elements>
        );

      case 2:
        return (
          <Elements stripe={stripePromise}>
            {/* <Payment onSubmit={(values) => handlePayment(values, state, dispatch, 'Resume')} state={state} dispatch={dispatch} loading={state.loading} /> */}
          </Elements>
        );
      // case 3:
      //   return <Confirmation state={state} />;

      // case 4:
      // case 5:
      //   return (
      //     <Elements stripe={stripePromise}>
      //       <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
      //         {state.step === 4 ? (
      //           <RegisterStep1 dispatch={dispatch} promo={state.promo} layout="renew" />
      //         ) : (
      //           <RegisterStep2
      //             onSubmit={(values) => handlePayment(values, state, dispatch, 'Renew')}
      //             state={state}
      //             dispatch={dispatch}
      //             loading={state.loading}
      //             layout="renew"
      //           />
      //         )}
      //       </GoogleReCaptchaProvider>
      //     </Elements>
      //   );

      default:
        return null;
    }
  };

  return renderStep();
};

const AccountPage: React.FC = () => (
  <Layout
    showNavOptions
    showCurrentUserDetails
    header
    footer={false}
  >
    <AccountContent />
  </Layout>
);

export default AccountPage;
